import Lottie from "lottie-react";
import LoadingAnimasi from "../assets/animasi/LoadingAnimasi.json";

export default function LoadingPage() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: 20,
        height: "100vh",
        width: "100vw",
        background:
          "linear-gradient(135deg, #f8fafc 0%, #eff6ff 50%, #f8fafc 100%)",
      }}
      className="dark-loading-bg"
    >
      <style>{`
                .dark-loading-bg { background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%) !important; }
                :root:not(.dark) .dark-loading-bg { background: linear-gradient(135deg, #f8fafc 0%, #eff6ff 50%, #f8fafc 100%) !important; }
                @keyframes lp-pulse { 0%,100% { opacity: 0.5; transform: scaleX(0.7); } 50% { opacity: 1; transform: scaleX(1); } }
                .lp-bar { height: 3px; border-radius: 99px; animation: lp-pulse 1.4s ease-in-out infinite; }
                .lp-bar:nth-child(2) { animation-delay: 0.2s; }
                .lp-bar:nth-child(3) { animation-delay: 0.4s; }
            `}</style>

      {/* Lottie */}
      <div style={{ width: "clamp(160px, 28vw, 260px)" }}>
        <Lottie animationData={LoadingAnimasi} loop={true} />
      </div>

      {/* Brand */}
      <div style={{ textAlign: "center" }}>
        <p
          style={{
            fontSize: "clamp(1.1rem, 3vw, 1.4rem)",
            fontStyle: "italic",
            color: "#2563eb",
            marginBottom: 4,
          }}
        >
          PPID Sampang
        </p>
        <p
          style={{
            fontSize: "0.75rem",
            fontWeight: 600,
            color: "#94a3b8",
            letterSpacing: "0.08em",
            textTransform: "uppercase",
          }}
        >
          Memuat...
        </p>
      </div>

      {/* Animated bars */}
      <div style={{ display: "flex", gap: 6 }}>
        {[80, 50, 65].map((w, i) => (
          <div
            key={i}
            className="lp-bar"
            style={{ width: w, background: `rgba(37,99,235,${0.3 + i * 0.2})` }}
          />
        ))}
      </div>
    </div>
  );
}
